'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function requestTrackingPixels() {
  var pixels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var timestampPlaceholder = '[timestamp]';

  if (pixels && pixels.length) {
    var timestamp = new Date().getTime();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = pixels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var trackingPixel = _step.value;

        try {
          if (trackingPixel && trackingPixel.length) {
            trackingPixel = trackingPixel.replace(timestampPlaceholder, timestamp);
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = trackingPixel;
            document.body.appendChild(iframe);
          }
        } catch (e) {
          // Nothing to do
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}

exports.default = requestTrackingPixels;